@if (userId) {
  @switch (type) {
    @case ('text') {
      @if (userCacheService.cache[userId]; as user) {
        @if (user.firstName) {
          {{ user.firstName | titlecase }}
          {{ user.lastName | titlecase }}
        } @else {
          {{ user.name }}
        }
      } @else {
        <div class="skeleton h-4 w-32"></div>
      }
    }

    @case ('card') {
      @if (userCacheService.cache[userId]; as user) {
        <div class="flex items-center space-x-2">
          @if (user.profileImage) {
            <div class="avatar">
              <div
                class="mask rounded-box"
                [class.w-8]="!small && !xs"
                [class.h-8]="!small && !xs"
                [class.w-6]="small"
                [class.h-6]="small"
                [class.w-4]="xs"
                [class.h-4]="xs">
                <img [src]="user.profileImage" alt="" />
              </div>
            </div>
          } @else {
            <div
              class="flex justify-center items-center bg-neutral rounded-box shrink-0"
              [class.w-8]="!small && !xs"
              [class.h-8]="!small && !xs"
              [class.w-6]="small"
              [class.h-6]="small"
              [class.w-4]="xs"
              [class.h-4]="xs">
              @if (
                user?.userType === UserType.AGENCY ||
                (!user?.userType && userType === UserType.AGENCY)
              ) {
                <fa-icon
                  [icon]="faBuildings"
                  [class.text-sm]="small"
                  [class.text-xs]="xs"></fa-icon>
              } @else {
                <fa-icon
                  [icon]="faUser"
                  [class.text-sm]="small"
                  [class.text-xs]="xs"></fa-icon>
              }
            </div>
          }
          <div class="grow">
            <div
              [class.font-bold]="!small"
              [class.text-sm]="small"
              [class.text-xs]="xs">
              @if (user.firstName) {
                {{ user.firstName | titlecase }}
                {{ user.lastName | titlecase }}
              } @else {
                {{ user.name }}
              }
            </div>

            @if (user$ | async; as authUser) {
              @if (authUser.type !== UserType.AGENT) {
                @if (showAgency) {
                  @if (user?.executives?.access?.[0]?.id) {
                    <span class="badge gap-2 badge-outline whitespace-nowrap">
                      <app-user-card
                        [userId]="user?.executives?.access?.[0]?.id"
                        [userType]="UserType.AGENCY"
                        [xs]="true"></app-user-card>
                    </span>
                  } @else if (user?.executives?.access?.[1]?.id) {
                    <span class="badge gap-2 badge-outline whitespace-nowrap">
                      <app-user-card
                        [userId]="user?.executives?.access?.[1]?.id"
                        [userType]="UserType.AGENCY"
                        [xs]="true"></app-user-card>
                    </span>
                  } @else if (user?.executives?.access?.[2]?.id) {
                    <span class="badge gap-2 badge-outline whitespace-nowrap">
                      <app-user-card
                        [userId]="user?.executives?.access?.[2]?.id"
                        [userType]="UserType.AGENCY"
                        [xs]="true"></app-user-card>
                    </span>
                  }
                }
              }
            }
          </div>

          @if (
            user.disabled &&
            user.disabled.startDate &&
            user.disabled.startDate.timestamp !== null &&
            user.disabled.startDate.timestamp !== undefined
          ) {
            @if (user.disabled.startDate.timestamp < now) {
              <a class="text-gray-500">
                <app-tooltip text="User is disabled">
                  <fa-icon [icon]="faBan"></fa-icon>
                </app-tooltip>
              </a>
            } @else {
              <a class="text-gray-400">
                <app-tooltip
                  [text]="
                    'User will be disabled on ' +
                    (user.disabled.startDate.timestamp | date: 'medium')
                  ">
                  <fa-icon [icon]="faBan"></fa-icon>
                </app-tooltip>
              </a>
            }
          }

          @if (user.userType && showUserType) {
            @if (userTypeMap[userTypeFromJSON(user.userType)]; as type) {
              <span
                class="badge gap-2"
                [class.bg-consumer]="type.color === 'consumer'"
                [class.text-consumer-content]="type.color === 'consumer'"
                [class.bg-agent]="type.color === 'agent'"
                [class.text-agent-content]="type.color === 'agent'"
                [class.bg-employee]="type.color === 'employee'"
                [class.text-employee-content]="type.color === 'employee'"
                [class.bg-agency]="type.color === 'agency'"
                [class.text-agency-content]="type.color === 'agency'"
                [class.bg-carrier]="type.color === 'carrier'"
                [class.text-carrier-content]="type.color === 'carrier'"
                [class.bg-publisher]="type.color === 'publisher'"
                [class.text-publisher-content]="type.color === 'publisher'"
                [class.bg-authority]="type.color === 'authority'"
                [class.text-authority-content]="type.color === 'authority'">
                @if (type.icon) {
                  <fa-icon [icon]="type.icon"></fa-icon>
                }
                {{ type.title }}
              </span>
            }
          }
        </div>
      } @else {
        <!-- {{ userId }} -->
        <div class="flex items-center space-x-3">
          <div class="avatar">
            <div class="rounded-box w-12 h-12">
              <div class="skeleton w-12 h-12 rounded-none"></div>
            </div>
          </div>
          <div>
            <div class="skeleton h-4 w-32"></div>
          </div>
        </div>
      }
    }
  }
}
